import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LovableFeedTab } from './lovable-feed-header.component';
import { LovablePost } from './lovable-dashboard.models';

@Component({
    selector: 'app-lovable-main-feed',
    templateUrl: './lovable-main-feed.component.html',
    styleUrls: ['./lovable-main-feed.component.css'],
})
export class LovableMainFeedComponent {
    @Input() posts: LovablePost[] = [];
    @Input() activeTab: LovableFeedTab = 'foryou';
    @Output() activeTabChange = new EventEmitter<LovableFeedTab>();
}
